import { Component, OnInit } from '@angular/core';
import { AlertService, RequestsStoreService, StaffStoreService } from "../../../_shared/services";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { Requests, StatusButtons } from "../../../_shared/interfaces";

import { ClrIconModule } from "@clr/angular";
import { RequestFormComponent } from "../request-form/request-form.component";
import { DatePipe, NgIf } from "@angular/common";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";

import { environment as env } from '../../../../environments/environment';

@Component({
  selector: 'app-request-update',
  standalone: true,
  imports: [
    RouterLink,
    ClrIconModule,
    RequestFormComponent,
    DatePipe,
    NgIf
  ],
  templateUrl: './request-update.component.html',
  styleUrl: './request-update.component.sass'
})

export class RequestUpdateComponent implements OnInit {
  projectId: string = '';
  requestId: number = 0;
  loading: boolean = true;
  requests: Requests[] = [];
  statusLabel = 'label-light-blue';
  statusText = '';
  staffFirstName: string = '';
  staffLastName: string = '';
  staffEMail: string = '';
  devMode: boolean;

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'label-light-blue', icon: 'info-circle'},
    { state: 'running', display: 'Abgeschickt', label: 'label-warning', icon: 'exclamation-triangle'},
    { state: 'rejected', display: 'Abgelehnt', label: 'label-danger', icon: 'exclamation-circle'},
    { state: 'too expensive', display: 'Zu teuer', label: 'label-info', icon: 'exclamation-circle'},
    { state: 'ignored', display: 'Ignoriert', label: 'label-info', icon: 'check-circle'},
    { state: 'answered', display: 'Beantwortet', label: 'label-info', icon: 'check-circle'},
    { state: 'favored', display: 'Auftrag', label: 'label-success', icon: 'check-circle'},
  ];

  constructor(
    private reqss: RequestsStoreService,
    private stss: StaffStoreService,
    private route: ActivatedRoute,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
    this.devMode = env.stages.dev;
  }

  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('prid') ?? '';
    this.requestId = parseInt(params.get('reqid') ?? '');
    this.loadRequest(this.projectId, this.requestId);
  }

  loadRequest(prid: string, reqid: number) {
    this.reqss.getRequests(prid, reqid, 'all').subscribe({
      next: data1 => {

        this.requests = data1.object;

        // Mitarbeiter personalisieren
        this.staffStatus(this.requests[0].employee_phm);
      },
      complete: () => {
        // Status gestalten
        const statusline = this.findButtonStatus(this.requests[0].status, this.statusButtons);
        this.statusLabel = this.statusButtons[statusline].label;
        this.statusText = this.statusButtons[statusline].display;

        this.loading = false;
      },
      error: () => {
        return;
      }
    });
  }

  staffStatus(staffID: number){
    if (this.devMode) console.log('StaffID ist ' + staffID);
    this.stss.getStaffById(staffID)
      .subscribe({
        next: staff => {

          this.staffFirstName = staff.object[0].firstname;
          this.staffLastName = staff.object[0].lastname;
          this.staffEMail = staff.object[0].email;
        },
        error: () => {
          return;
        }
      });
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

}
